import { toBrowserPath } from "./hamiPaths";

/**
 * Canonical profile page URLs for sharing and navigation.
 */

export function getProfilePath(remoteId) {
  if (remoteId == null || remoteId === "") return null;
  return `/chat-profile/${encodeURIComponent(String(remoteId))}`;
}

export function getProfileShareUrl(remoteId) {
  const path = getProfilePath(remoteId);
  if (!path) return null;
  if (typeof window === "undefined") return path;
  return `${window.location.origin}${toBrowserPath(path)}`;
}
